export default "__VITE_ASSET__BppHFqjS__"